import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { IQuebecObstetricalFileFormPage } from "@/Patient/Models/ObstetricalFile/Quebec/IQuebecObstetricalFileFormPage";
import { QuebecObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/Quebec/QuebecObstetricalFileForm";
import { WeightUnitComponent } from "../Common/Subcomponent/WeightUnitComponent";
import { ObstetricalFilePage, ObstetricalFilePageState } from "../ObstetricalFilePage";
import { QuebecObstetricalFilePageHeader } from "./QuebecObstetricalFilePageHeader";

abstract class QuebecObstetricalFilePageState extends ObstetricalFilePageState<QuebecObstetricalFileForm> {
    public pageModel: IQuebecObstetricalFileFormPage;
}

abstract class QuebecObstetricalFilePage<TState extends QuebecObstetricalFilePageState> extends ObstetricalFilePage<QuebecObstetricalFileForm, TState> {
    public render(): JSX.Element {
        return (
            <div className="page">
                {this.renderPageHeader()}
                {this.renderPageContent()}
            </div>
        );
    }

    protected renderWeightUnit(selectedUnit: WeightUnit, onChange: (u: WeightUnit) => void): JSX.Element {
        return (
            <WeightUnitComponent
                units={[WeightUnit.Kilogram, WeightUnit.Pound]}
                selectedUnit={selectedUnit}
                onUnitChange={onChange}
                readonly={this.props.readonly}
            />
        );
    }

    private renderPageHeader(): JSX.Element {
        return (
            <QuebecObstetricalFilePageHeader
                {...this.props}
                summary={this.state.pageModel.Summary}
                isExtended={this.props.isPageHeaderExtended}
                onHeaderToggle={() => this.props.onHeaderToggle?.()}
                onSummaryChange={summary => this.mutateState(s => s.pageModel.Summary = summary)}
                onSummaryBlur={() => this.handleFormUpdate()}
            />
        );
    }
}

export { QuebecObstetricalFilePage, QuebecObstetricalFilePageState };
